import {
    CREATE_INVENTORY,
    CREATE_INVENTORY_FAIL,
    CREATE_INVENTORY_SUCCESS,
    DELETE_INVENTORY,
    DELETE_INVENTORY_FAIL,
    DELETE_INVENTORY_SUCCESS,
    GET_INVENTORY_DETAILS,
    GET_INVENTORY_DETAILS_FAIL,
    GET_INVENTORY_DETAILS_SUCCESS,
    GET_INVENTORY_FILTERS,
    GET_INVENTORY_FILTERS_FAIL,
    GET_INVENTORY_FILTERS_SUCCESS,
    GET_INVENTORY_STOCK_STATUSES,
    GET_INVENTORY_STOCK_STATUSES_FAIL,
    GET_INVENTORY_STOCK_STATUSES_SUCCESS,
    GET_INVENTORY_LISTING,
    GET_INVENTORY_LISTING_FAIL,
    GET_INVENTORY_LISTING_SUCCESS,
    RESET_INVENTORY_ACTION_STATE,
    RESET_INVENTORY_STATE,
    UPDATE_INVENTORY,
    UPDATE_INVENTORY_FAIL,
    UPDATE_INVENTORY_SUCCESS
} from "./actionTypes";

export const getInventoryListing = (data) => ({
    type: GET_INVENTORY_LISTING,
    payload: data,
});

export const getInventoryListingSuccess = data => ({
    type: GET_INVENTORY_LISTING_SUCCESS,
    payload: data,
});

export const getInventoryListingFail = error => ({
    type: GET_INVENTORY_LISTING_FAIL,
    payload: error,
});

export const getInventoryDetails = (data) => ({
    type: GET_INVENTORY_DETAILS,
    payload: data,
});

export const getInventoryDetailsSuccess = data => ({
    type: GET_INVENTORY_DETAILS_SUCCESS,
    payload: data,
});

export const getInventoryDetailsFail = error => ({
    type: GET_INVENTORY_DETAILS_FAIL,
    payload: error,
});

export const getInventoryFilters = () => ({ type: GET_INVENTORY_FILTERS });
export const getInventoryFiltersSuccess = data => ({ type: GET_INVENTORY_FILTERS_SUCCESS, payload: data });
export const getInventoryFiltersFail = error => ({ type: GET_INVENTORY_FILTERS_FAIL, payload: error });

export const getInventoryStockStatuses = () => ({ type: GET_INVENTORY_STOCK_STATUSES });
export const getInventoryStockStatusesSuccess = data => ({ type: GET_INVENTORY_STOCK_STATUSES_SUCCESS, payload: data });
export const getInventoryStockStatusesFail = error => ({ type: GET_INVENTORY_STOCK_STATUSES_FAIL, payload: error });

export const createInventory = (data) => ({
    type: CREATE_INVENTORY,
    payload: data,
});

export const createInventorySuccess = data => ({
    type: CREATE_INVENTORY_SUCCESS,
    payload: data,
});

export const createInventoryFail = error => ({
    type: CREATE_INVENTORY_FAIL,
    payload: error,
});

export const updateInventory = (data) => ({
    type: UPDATE_INVENTORY,
    payload: data,
});

export const updateInventorySuccess = data => ({
    type: UPDATE_INVENTORY_SUCCESS,
    payload: data,
});

export const updateInventoryFail = error => ({
    type: UPDATE_INVENTORY_FAIL,
    payload: error,
});

export const deleteInventory = (data) => ({
    type: DELETE_INVENTORY,
    payload: data,
});

export const deleteInventorySuccess = data => ({
    type: DELETE_INVENTORY_SUCCESS,
    payload: data,
});

export const deleteInventoryFail = error => ({
    type: DELETE_INVENTORY_FAIL,
    payload: error,
});

//reset
export const resetInventoryActionState = () => {
    return {
        type: RESET_INVENTORY_ACTION_STATE,
    }
}
export const resetInventoryState = () => {
    return {
        type: RESET_INVENTORY_STATE,
    }
}

